import { render } from "./appRedirect.vue?vue&type=template&id=2460fce8"
import script from "./appRedirect.vue?vue&type=script&lang=js"
export * from "./appRedirect.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__